module.exports = {
          srcSet: __webpack_public_path__ + "d54bc414f0f6de8d6cd2ef436fa80d12-26.png"+" 26w",
          images:[ {path: __webpack_public_path__ + "d54bc414f0f6de8d6cd2ef436fa80d12-26.png",width: 26,height: 26}],
          src: __webpack_public_path__ + "d54bc414f0f6de8d6cd2ef436fa80d12-26.png",
          toString:function(){return __webpack_public_path__ + "d54bc414f0f6de8d6cd2ef436fa80d12-26.png"},
          
          width: 26,
          height: 26
        }